import * as types from '@/store/types';
import { IConfirm } from '@/entities/confirm.interface';

interface State {
    confirm: IConfirm;
}

const initialState: State = {
    confirm: null
};

const getters = {
    [types.GET_CONFIRM]: (state: State) => {
        return state.confirm;
    }
};

const mutations = {
    [types.SHOW_CONFIRM]: (state: State, payload: IConfirm) => {
        state.confirm = payload;
    },
    [types.CLOSE_CONFIRM]: (state: State) => {
        state.confirm = null;
    }
};

const actions = {
    [types.SHOW_CONFIRM]: ({ commit }, payload: IConfirm) => {
        document.body.classList.add('no-scroll');
        commit(types.SHOW_CONFIRM, payload);
    },
    [types.CLOSE_CONFIRM]: ({ commit }) => {
        document.body.classList.remove('no-scroll');
        commit(types.CLOSE_CONFIRM);
    }
};

export default {
    state: initialState,
    mutations,
    actions,
    getters
};
